import { ReactElement } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { SearchIcon } from 'src/v3/core/icons'
import { paperInputSx } from '../styles'

type Group = {
  id?: string
  name: string
  users?: string[]
}

type UserFiltersProps = {
  searchQuery: string
  onSearchChange: (value: string) => void
  groupFilter: string
  onGroupChange: (value: string) => void
  groups: Group[]
}

export default function UserFilters({
  searchQuery,
  onSearchChange,
  groupFilter,
  onGroupChange,
  groups,
}: UserFiltersProps): ReactElement {
  let hasNoGroups = groups.length === 0

  return (
    <Box className="grid grid-cols-1 gap-6 mb-3 md:grid-cols-2">
      <TextField
        fullWidth
        label="Search Users"
        placeholder="Search by name or email..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: <SearchIcon className="mr-2" />,
          },
        }}
        sx={paperInputSx}
      />

      <FormControl fullWidth disabled={hasNoGroups}>
        <InputLabel id="group-filter-label">Search by Group</InputLabel>
        <Select
          labelId="group-filter-label"
          value={hasNoGroups ? 'no-groups' : groupFilter}
          onChange={(e) => onGroupChange(e.target.value)}
          label="Search by Group"
          sx={{ backgroundColor: 'background.paper' }}
        >
          {hasNoGroups ? (
            <MenuItem value="no-groups" selected>
              <em>No Groups Available</em>
            </MenuItem>
          ) : (
            <MenuItem value="">
              <em>All Groups</em>
            </MenuItem>
          )}
          {groups.map((g) => (
            <MenuItem key={g.id} value={g.id}>
              {g.name} ({g.users?.length || 0} users)
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
